import React, { useState, useEffect } from 'react';
import { WABA_PLANNING_TRIGGER } from '../../../config/api';

function PlanningHistoryCard({ plans }) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const updateSize = () => setIsMobile(window.innerWidth <= 768);
    updateSize();
    window.addEventListener('resize', updateSize);
    return () => window.removeEventListener('resize', updateSize);
  }, []);

  if (!Array.isArray(plans) || plans.length === 0) return null;

  const totalQty = plans.reduce((sum, row) => sum + parseFloat(row.planned_qty || 0), 0);

  const renderStatus = (plan) => {
    if (plan.is_invoiced) return <span className="badge bg-success">Invoiced</span>;
    if (plan.is_dispatched) return <span className="badge bg-warning text-dark">Dispatch Planned</span>;
    return <span className="badge bg-secondary">Pending</span>;
  };

  const sendWabaMessage = async (planId) => {
    try {
      const res = await fetch(WABA_PLANNING_TRIGGER, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ plan_id: planId })
      });

      const text = await res.text();
      if (text) {
        const json = JSON.parse(text);
        if (json.success) {
          alert('✅ WABA Message Sent!');
        } else {
          alert('⚠️ WABA Failed: ' + (json.error || 'Unknown error'));
        }
      } else {
        alert('⚠️ Empty response from WABA API.');
      }
    } catch (err) {
      console.error('WABA API error:', err);
      alert('🚫 WABA Error: ' + err.message);
    }
  };

  return (
    <div className="card mt-4 shadow-sm rounded-4 border border-primary">
      <div className="card-body p-3">
        <h6 className="card-title text-primary fw-semibold mb-3 small">Existing Planning History</h6>

        {!isMobile ? (
          <table className="table table-bordered table-striped table-sm text-nowrap small align-middle">
            <thead className="table-info text-dark">
              <tr>
                <th>#</th>
                <th>Material</th>
                <th>Packing</th>
                <th className="text-end">Planned Qty</th>
                <th className="text-end">Dispatched Qty</th>
                <th>Delivery</th>
                <th>Destination</th>
                <th>Priority</th>
                <th>Remark</th>
                <th>Status</th>
                <th>Created By</th>
                <th>Created</th>
                <th>Updated By</th>
                <th>Updated</th>
                <th>WhatsApp</th>
              </tr>
            </thead>
            <tbody>
              {plans.map((plan, index) => (
                <tr key={plan.id} id={`plan-row-${plan.id}`} className={index % 2 === 0 ? 'table-light' : ''}>
                  <td>{index + 1}</td>
                  <td>{plan.material_name}</td>
                  <td>{plan.packing_style}</td>
                  <td className="text-end">{Number(plan.planned_qty).toFixed(3)}</td>
                  <td className="text-end">{Number(plan.dispatched_qty).toFixed(3)}</td>
                  <td>{plan.delivery_date}</td>
                  <td>{plan.destination}</td>
                  <td>{plan.priority}</td>
                  <td>{plan.remark}</td>
                  <td>{renderStatus(plan)}</td>
                  <td><span title={plan.created_at}>{plan.created_by_name}</span></td>
                  <td><span title={plan.created_at}>{plan.created_at?.slice(0, 10)}</span></td>
                  <td><span title={plan.updated_at}>{plan.updated_by_name}</span></td>
                  <td><span title={plan.updated_at}>{plan.updated_at?.slice(0, 10)}</span></td>
                  <td>
                    <button
                      className="btn btn-sm btn-outline-success"
                      onClick={() => sendWabaMessage(plan.id)}
                    >
                      📤 Send
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr className="table-light fw-bold">
                <td colSpan="3" className="text-end">Total</td>
                <td className="text-end">{totalQty.toFixed(3)}</td>
                <td colSpan="11"></td>
              </tr>
            </tfoot>
          </table>
        ) : (
          <div className="row row-cols-1 g-3">
            {plans.map((plan, index) => (
              <div key={plan.id} className="card border shadow-sm">
                <div className="card-body p-2 small">
                  <div className="d-flex justify-content-between">
                    <strong>{plan.material_name}</strong>
                    <span>{renderStatus(plan)}</span>
                  </div>
                  <div><b>Packing:</b> {plan.packing_style}</div>
                  <div><b>Planned:</b> {Number(plan.planned_qty).toFixed(3)} | <b>Dispatched:</b> {Number(plan.dispatched_qty).toFixed(3)}</div>
                  <div><b>Delivery:</b> {plan.delivery_date} | <b>Destination:</b> {plan.destination}</div>
                  <div><b>Priority:</b> {plan.priority}</div>
                  <div><b>Remark:</b> {plan.remark}</div>
                  <div className="mt-1"><b>Created:</b> {plan.created_by_name} ({plan.created_at?.slice(0, 10)})</div>
                  <div><b>Updated:</b> {plan.updated_by_name} ({plan.updated_at?.slice(0, 10)})</div>
                  <div className="text-end mt-2">
                    <button
                      className="btn btn-sm btn-outline-success"
                      onClick={() => sendWabaMessage(plan.id)}
                    >
                      📤 Send Whatsapp
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default PlanningHistoryCard;
